import Vue from "vue";
import Router from "vue-router";
import HomePage from "@/components/HomePage";
import NotePage from "@/components/NotePage";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "HomePage",
      component: HomePage,
    },
    {
      path: "/note/:yearParam/:monthParam/:dateParam",
      name: "NotePage",
      component: NotePage,
      props: true,
    },
  ],
  mode: "history",
});



// WEBPACK FOOTER //
// ./src/router/index.js